import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { COLORS } from '../constants/constants';
import { useTranslation } from 'react-i18next';
import { getVideoSrc } from '../constants/constants';

export default function CustomizePDFs({ }) {
    const { t, i18n } = useTranslation();
    return (
        <Box
            component="section"
            backgroundColor={COLORS.greyICB}
            sx={[
                {
                    mt: { xs: 2, md: 2 },
                    paddingTop: { xs: 5, md: 5 },
                    width: '95%',
                    margin: 'auto',
                    maxWidth: '1000px',
                    borderRadius: 6,
                },
            ]}
        >
            <Container>
                <Box
                    sx={{
                        gap: 3,
                        pb: 10,
                        display: 'flex',
                        borderRadius: 3,
                        textAlign: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        bgcolor: 'background.neutral',
                    }}
                >
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{
                            width: '100%',
                            maxWidth: 800,
                            height: 'auto',
                            objectFit: 'contain',
                            borderRadius: 8,
                        }}
                        aria-label="iCoachBasketball practice customization demo"
                    >
                        <source src={getVideoSrc('customize-pdfs', i18n.language)} type="video/mp4" />
                        Tu navegador no soporta el elemento de video.getVideoSrc
                    </video>

                    <Typography
                        variant="overline"
                        sx={{
                            color: 'text.disabled',
                            fontFamily: 'Barlow, sans-serif',
                        }}
                    >
                        {t('CustomizePDFs00')}
                    </Typography>

                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.2rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            color: '#1a202c',
                        }}
                    >
                        {t('CustomizePDFs01')}
                        <Box
                            component="span"
                            sx={{
                                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            {` ${t('CustomizePDFs02')}`}
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: 'text.secondary',
                            maxWidth: 480,
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '1.1rem',
                            lineHeight: 1.2,
                        }}
                    >
                        {t('CustomizePDFs03')}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}